export const spacing = {
  none: 0,
  '2xs': 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  '2xl': 32,
  '3xl': 40,
} as const;

export type SpacingToken = keyof typeof spacing;

export const getSpacing = (value: SpacingToken | number): number => {
  if (typeof value === 'number') {
    return value;
  }

  return spacing[value];
};
